const HEX = /^#[0-9A-Fa-f]{6}$/;
const DEFAULT_PRIMARY = '#a63726';
const DEFAULT_SECONDARY = '#292724';
const PRIMARY_PROPS = ['--ws-primary', '--ws-primary-hover', '--ws-primary-dark', '--ws-primary-light', '--ws-primary-border', '--ws-focus-ring'];

function channels(hex) {
  return [1, 3, 5].map((index) => parseInt(hex.slice(index, index + 2), 16));
}

function mix(hex, toward, weight) {
  const from = channels(hex);
  const to = channels(toward);
  const mixed = from.map((value, index) => Math.round(value + (to[index] - value) * weight));
  return `#${mixed.map((value) => value.toString(16).padStart(2, '0')).join('')}`;
}

export function applyBrandColours(primary, secondary) {
  const root = document.documentElement;
  const accent = HEX.test(primary || '') ? primary.toLowerCase() : '';
  const ink = HEX.test(secondary || '') ? secondary.toLowerCase() : '';
  if (accent && accent !== DEFAULT_PRIMARY) {
    const [red, green, blue] = channels(accent);
    root.style.setProperty('--ws-primary', accent);
    root.style.setProperty('--ws-primary-hover', mix(accent, '#000000', 0.12));
    root.style.setProperty('--ws-primary-dark', mix(accent, '#000000', 0.28));
    root.style.setProperty('--ws-primary-light', mix(accent, '#ffffff', 0.9));
    root.style.setProperty('--ws-primary-border', mix(accent, '#ffffff', 0.7));
    root.style.setProperty('--ws-focus-ring', `rgba(${red}, ${green}, ${blue}, 0.35)`);
  } else {
    PRIMARY_PROPS.forEach((name) => root.style.removeProperty(name));
  }
  if (ink && ink !== DEFAULT_SECONDARY) root.style.setProperty('--ws-charcoal', ink);
  else root.style.removeProperty('--ws-charcoal');
}
